'use strict';

const IdeaRepository = require('feedback/domain/repository/idea');
const IdeaCollection = require('feedback/domain/collection/idea');
const AdminIdeaCollection = require('feedback/domain/collection/idea-admin');

class IdeaCollectionRepository {
    constructor() {
        this._repo = IdeaRepository;
        this._ideas = {};
        this._ideasByQuery = {};
    }

    userIdeas(user) {
        const key = `my:${user.id}`;
        let ideas = this._ideas[key];
        if (!ideas) {
            ideas = new IdeaCollection([], {
                repository: this._repo,
                scope: "my",
                user: user
            });
            this._ideas[key] = ideas;
        }
        return ideas;
    }

    publicIdeas(user) {
        const key = `public:${user.id}`;
        let ideas = this._ideas[key];
        if (!ideas) {
            ideas = new IdeaCollection([], {
                repository: this._repo,
                scope: "public",
                user: user
            });
            this._ideas[key] = ideas;
        }
        return ideas;
    }

    adminIdeasByQuery(query) {
        let ideas = this._ideasByQuery[query];
        if(!ideas) {
            ideas = new AdminIdeaCollection([], {
                repository: this._repo,
                query: query
            });
            this._ideasByQuery[query] = ideas;
        }

        return ideas;
    }
}

module.exports = new IdeaCollectionRepository();



// WEBPACK FOOTER //
// ./feedback/domain/repository/idea-collection.js